import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import SportPage from "./pages/SportPage";
import UpcomingSoccerPage from "./pages/UpcomingSoccerPage";
import UpcomingSportPage from "./pages/UpcomingSportPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import BlogTagPage from './pages/BlogTagPage';
import FAQ from "./pages/FAQ";
import SpoilerFreeAlternatives from "./pages/SpoilerFreeAlternatives";
// import BestGamesPage from "./pages/BestGamesPage"; // Removed import for deleted page
// import BlogCategoryPage from "./pages/blog/BlogCategoryPage"; // Removed import for category page
import { CookieConsentProvider } from "./contexts/CookieConsentContext";
import CookieConsent from "./components/CookieConsent";
import { LocalAppStateProvider } from "./contexts/LocalAppStateContext";
import NativeAppBridge from "./components/NativeAppBridge";
import AnalyticsScripts from "./components/AnalyticsScripts";
import UpcomingHub from "./pages/UpcomingHub";
import MyReplayPlan from "./pages/MyReplayPlan";
import AppSettings from "./pages/AppSettings";
import Onboarding from "./pages/Onboarding";
import OnboardingGate from "./components/OnboardingGate";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <CookieConsentProvider>
      <LocalAppStateProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <NativeAppBridge />
          <ScrollToTop />
          <OnboardingGate>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sport/nba" element={<SportPage sport="nba" />} />
            <Route path="/sport/nba/upcoming" element={<UpcomingSportPage sport="nba" />} />
            <Route path="/sport/soccer" element={<SportPage sport="soccer" />} />
            <Route path="/sport/soccer/upcoming" element={<UpcomingSoccerPage />} />
            {/* Removed the competition-specific path since we're using query params now */}
            <Route path="/sport/nfl" element={<SportPage sport="nfl" />} />
            <Route path="/sport/nfl/upcoming" element={<UpcomingSportPage sport="nfl" />} />
            <Route path="/sport/mlb" element={<SportPage sport="mlb" />} />
            <Route path="/sport/mlb/upcoming" element={<UpcomingSportPage sport="mlb" />} />
            <Route path="/sport/nhl" element={<SportPage sport="nhl" />} />
            <Route path="/sport/nhl/upcoming" element={<UpcomingSportPage sport="nhl" />} />
            <Route path="/upcoming" element={<UpcomingHub />} />
            <Route path="/plan" element={<MyReplayPlan />} />
            <Route path="/settings" element={<AppSettings />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/spoiler-free-sports-alternatives" element={<SpoilerFreeAlternatives />} />
            <Route path="/blog" element={<BlogIndex />} />
            {/* Updated blog post route to use date-based path structure */}
            <Route path="/blog/:year/:month/:day/:slug" element={<BlogPost />} />
            <Route path="/blog/tags/:tagName" element={<BlogTagPage />} />
            {/* <Route path="/blog/categories/:categoryName" element={<BlogCategoryPage />} /> */}
            
            {/* Seasonal/Event Pages */}
            {/* <Route path="/features/best-games/:year/:month" element={<BestGamesPage />} /> */}

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </OnboardingGate>
          <AnalyticsScripts />
          <CookieConsent />
        </BrowserRouter>
      </TooltipProvider>
      </LocalAppStateProvider>
    </CookieConsentProvider>
  </QueryClientProvider>
);

export default App;
